import React, { useState, useEffect } from 'react';
import {
	Typography,
	Radio,
	Row,
	Col,
	Upload,
	Button,
	notification,
	Dropdown,
	Space,
	message,
	Card
} from 'antd';
import { useSelector } from 'react-redux';
import axios from 'axios';
import env from '../../../environment';
import { useTranslation } from 'react-i18next';
import { refreshData } from '../../../store/auth/actions';
import {
	CheckOutlined,
	DeleteOutlined,
	DownloadOutlined,
	MoreOutlined,
	LikeOutlined,
	ExclamationCircleOutlined,
	ClockCircleOutlined,
	FileOutlined
} from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import _ from 'lodash';
import { showPay } from '../../../store/data/actions';
import { useDispatch } from 'react-redux';
import CheckOutComponent from '../CheckOutComponent';
import plusDocuments from '../../../assets/onboarding/plusDocuments.png';
import moment from 'moment';
import tagSabadell from '../../../components/tagSabadell';
import eventSabadell from '../../../components/eventSabadell';
import DeleteDocumentModal from 'mortgage-documents/src/document-boxes/modals/DeleteDocumentModal';

const { Text } = Typography;

const Appraisal = ({ dataMortgage, operationId, existAppraisal, getAppraisal }) => {
	const userToken = useSelector((state) => state.auth.token);
	const [valueRadio, setValueRadio] = useState(undefined);
	const [mortgageData, setMortgageData] = useState();
	const [isClientPay, setIsClientPay] = useState(false);
	const { t, i18n } = useTranslation();
	const [saveFileDataField, setSaveFileDataField] = useState(null);
	const [typeFile, setTypeFile] = useState();
	const dispatch = useDispatch();
	const showPayBoolean = useSelector((state) => state.data.showPay);
	const [dataClient, setDataClient] = useState('');
	const [deleteModal, setDeleteModal] = useState({ show: false, documentId: undefined });
	const [bankOffer, setBankOffer] = useState();

	useEffect(() => {
		if (operationId) {
			getMortgageData();
			getClientPay();
			getTokenPay();
			eventSabadell('ya tengo');
			getBankOffer();
		}
	}, []);

	useEffect(() => {
		getClientPay();
	}, [showPayBoolean]);

	const getTokenPay = () => {
		axios
			.post(
				`${env.api.url}/v1/payments/appraisal/checkout`,
				{
					operationId: operationId
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setDataClient(response.data.data);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const getBankOffer = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/selected-bank-offer/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setBankOffer(response.data.data.selectedOffer);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getMortgageData = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/data/get/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setMortgageData(response.data.data.mortgage);
				if (response.data.data.mortgage.reportAppraisal !== undefined) {
					setValueRadio(response.data.data.mortgage.reportAppraisal);
				}
			});
	};

	const getClientPay = () => {
		axios
			.post(
				`${env.api.url}/v1/payments/operation/status`,
				{
					operationId: operationId
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setIsClientPay(response.data.data.completed);
			});
	};

	const handleUploadFile = (file) => {
		if (
			file[1].fileName.includes('.jpg') ||
			file[1].fileName.includes('.jpeg') ||
			file[1].fileName.includes('.png') ||
			file[1].fileName.includes('.pdf') ||
			file[1].fileName.includes('.xlsx') ||
			file[1].fileName.includes('.doc') ||
			file[1].fileName.includes('.docx') ||
			file[1].fileName.includes('.heic') ||
			file[1].fileName.includes('.webp')
		) {
			axios
				.put(
					`${env.api.url}/api/mortgages/attachment`,
					{
						mortgageId: operationId,
						file: file[1].file,
						fileName: file[1].fileName,
						type: typeFile,
						owner: 'owner1'
					},
					{
						headers: { Authorization: `Bearer ${userToken}` }
					}
				)
				.then((response) => {
					getAppraisal();
					if (response?.data?.type === 'appraisal') {
						message.success({
							style: {
								border: '2px solid #239D45',
								width: 'fit-content',
								margin: '0 auto',
								background: '#fff',
								borderRadius: 4,
								textAlign: 'left'
							},
							content: (
								<Text style={{ fontSize: 16, color: '#239D45', fontWeight: 500 }}>
									{t('doc.notiNew')}
									<br />
									<span style={{ fontSize: 14, fontWeight: 400, color: '#212121', marginLeft: 24 }}>
										{t('appraisal.contactMessage')}
									</span>
								</Text>
							),
							icon: <LikeOutlined style={{ color: '#239D45' }} />
						});
					}
				})
				.catch(() => {
					message.error({
						style: {
							border: '2px solid #BE0028',
							width: 'fit-content',
							margin: '0 auto',
							background: '#fff',
							borderRadius: 4,
							textAlign: 'left'
						},
						content: (
							<Text style={{ fontSize: 16, color: '#BE0028', fontWeight: 500 }}>
								{t('doc.errorOcurred')}
								<br />
								<span style={{ fontSize: 14, fontWeight: 400, color: '#212121', marginLeft: 24 }}>
									{t('doc.reuploadDocument')}
								</span>
							</Text>
						),
						icon: <ExclamationCircleOutlined style={{ color: '#BE0028' }} />
					});
				});
		} else {
			message.error({
				style: {
					border: '2px solid #BE0028',
					width: 'fit-content',
					margin: '0 auto',
					background: '#fff',
					borderRadius: 4,
					textAlign: 'left'
				},
				content: (
					<Text style={{ fontSize: 16, color: '#BE0028', fontWeight: 500 }}>
						{t('doc.errorOcurred')}
						<br />
						<span style={{ fontSize: 14, fontWeight: 400, color: '#212121', marginLeft: 24 }}>
							{t('files.allowedFormats')}
						</span>
					</Text>
				),
				icon: <ExclamationCircleOutlined style={{ color: '#BE0028' }} />
			});
		}
	};

	const saveFileData = (file, name) => {
		const documentFile = [saveFileDataField];
		documentFile.push({
			file,
			fileName: name
		});
		setSaveFileDataField(documentFile);
		handleUploadFile(documentFile);
	};

	const uploadProps = {
		beforeUpload: (file) => {
			return new Promise(() => {
				const reader = new FileReader();
				reader.readAsDataURL(file);

				if (file.size < 50000000) {
					reader.onload = () => {
						const base64File = reader.result.split(',')[1];
						saveFileData(base64File, file.name);
					};
				} else {
					notification.error({
						message: 'Problema al subir archivo',
						description:
							'Documento demasiado pesado, debe subir documentos que no superen los 50MB por seguridad.'
					});
				}
			});
		}
	};

	const handleClickPlus = (typeFile) => {
		tagSabadell('tasacion informe propia', i18n.language === 'cat' ? 'ca' : 'es');
		setTypeFile(typeFile);
		getAppraisal();
	};

	const deleteDocument = () => {
		if (!_.isNil(existAppraisal.page)) {
		} else {
			axios
				.get(`${env.api.url}/v1/documents/delete-document/${existAppraisal.id}`, {
					headers: { Authorization: `Bearer ${userToken}` }
				})
				.then(() => {
					setDeleteModal({ show: false, documentId: undefined });
					getAppraisal();
				})
				.catch(() => {
					undefined;
				});
		}
	};

	const handleFileDownload = (documentId) => {
		axios
			.get(`${env.api.url}/v1/documents/get-document-url/${documentId}?token=${userToken}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				if (response.data.success) {
					window.open(response.data.data.url, '_blank');
				}
			})
			.catch(() => {
				undefined;
			});
	};

	const saveDataOnClick = (participant, key, value) => {
		let valueRadio = {
			key: 'operation',
			subkey: 'firstClickToAppraisal',
			value: moment().format('YYYY-MM-DD')
		};

		if (mortgageData.reportAppraisal !== undefined) {
			valueRadio = {
				key: 'operation',
				subkey: 'ultimateClickToAppraisal',
				value: moment().format('YYYY-MM-DD')
			};
		}

		axios
			.post(
				`${env.api.url}/v1/mortgages/data/multiple/update/${operationId}`,
				{
					values: [
						{
							key: participant,
							subkey: key,
							value: value
						},
						{
							key: valueRadio.key,
							subkey: valueRadio.subkey,
							value: valueRadio.value
						}
					]
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then(() => {
				getMortgageData();
				refreshData();
			});
	};

	const items = [
		{
			key: 'delete',
			icon: <DeleteOutlined />,
			label: t('loan.delete'),
			danger: true,
			onClick: () => setDeleteModal({ show: true, documentId: existAppraisal.id })
		},
		{
			key: 'download',
			icon: <DownloadOutlined style={{ color: '#006DFF' }} />,
			label: <div style={{ color: '#006DFF', width: '100%' }}>{t('init.download')}</div>,
			onClick: () => handleFileDownload(existAppraisal.id)
		}
	];

	const renderSelect = () => {
		return (
			<div style={{ marginTop: 8 }}>
				{_.isNil(mortgageData?.appraiser) && (
					<Text style={{ color: '#757575', fontSize: 14, fontWeight: 400 }}>
						{t('m_appraisal.sectionTitle')}
					</Text>
				)}
				{!isClientPay && (
					<Row style={{ marginTop: 16, display: 'flex', width: '100%' }}>
						<Col span={24} style={{ textAlign: 'left', width: '100%' }}>
							<Radio
								value={'own'}
								checked={mortgageData && mortgageData.reportAppraisal === 'own' ? true : false}
								onChange={(e) => {
									saveDataOnClick('mortgage', 'reportAppraisal', e.target.value);
									setValueRadio(e.target.value);
									eventSabadell('ya tengo');
									tagSabadell('tasacion propia', i18n.language === 'cat' ? 'ca' : 'es');
								}}>
								<Text
									style={{
										color: '#212121',
										fontSize: 14,
										fontWeight: mortgageData?.reportAppraisal === 'own' ? 700 : 400
									}}>
									{t('appraisal.miAppraisal')}
								</Text>
							</Radio>
						</Col>
					</Row>
				)}
				{valueRadio !== 'h1' &&
					!_.isNil(valueRadio) &&
					existAppraisal === undefined &&
					mortgageData &&
					mortgageData.reportAppraisal !== 'bank' && (
						<div style={{ marginTop: 8, marginBottom: 12 }}>
							<Upload {...uploadProps}>
								<Button
									onClick={() => handleClickPlus('appraisal')}
									style={{
										width: 'auto',
										height: 78,
										backgroundColor: 'white',
										borderRadius: '4px',
										borderColor: '#BE0028'
									}}>
									<div style={{ display: 'flex', alignItems: 'center', columnGap: 9 }}>
										<div
											style={{ height: 6, width: 6, background: 'red', borderRadius: '50%' }}></div>
										<div
											style={{
												fontSize: '12px',
												whiteSpace: 'break-spaces',
												color: '#212121',
												fontWeight: 400
											}}>
											{t('appraisal.infoAppraisal')}
										</div>
									</div>
									<div style={{ display: 'flex', alignItems: 'center', columnGap: 4 }}>
										<img src={plusDocuments} alt="plusDocuments" height={16} />
										<div
											style={{
												fontSize: '12px',
												whiteSpace: 'break-spaces',
												color: '#006DFF',
												fontWeight: 400,
												textDecorationLine: 'underline'
											}}>
											{t('document.attach')}
										</div>
									</div>
								</Button>
							</Upload>
						</div>
					)}

				{valueRadio !== 'h1' && existAppraisal && existAppraisal?.type === 'appraisal' && (
					<div style={{ marginTop: 8, marginBottom: 12 }}>
						<div
							// onClick={() => handleClickPlus('appraisal')}
							style={{
								width: 168,
								height: 78,
								padding: '4px 15px',
								borderRadius: '4px',
								border: '1px solid #239D45'
							}}>
							<div style={{ display: 'flex', alignItems: 'center', columnGap: 9 }}>
								<CheckOutlined style={{ color: '#52C41A' }} />
								<div
									style={{
										fontSize: '12px',
										whiteSpace: 'break-spaces',
										color: '#212121',
										fontWeight: 400
									}}>
									{t('appraisal.infoAppraisal')}
								</div>
							</div>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
									columnGap: 4,
									marginTop: 8
								}}>
								<div
									style={{
										fontSize: '12px',
										whiteSpace: 'break-spaces',
										color: '#757575',
										fontWeight: 400
									}}>
									{t('appraisal.appraisal')}.pdf
								</div>
								<Dropdown
									menu={{ items }}
									trigger={['click']}
									getPopupContainer={(trigger) => trigger.parentNode}>
									<Button style={{ border: 'none', boxShadow: 'none', padding: 0 }}>
										<MoreOutlined />
									</Button>
								</Dropdown>
							</div>
						</div>
					</div>
				)}

				<Row style={{ marginTop: !_.isNil(mortgageData?.appraiser) ? 20 : 8 }}>
					<Col span={24}>
						{isClientPay === false && (
							<Radio
								value={'h1'}
								checked={mortgageData && mortgageData.reportAppraisal === 'h1' ? true : false}
								onChange={(e) => {
									saveDataOnClick('mortgage', 'reportAppraisal', e.target.value);
									setValueRadio(e.target.value);
									eventSabadell('tasacion sabadell');
								}}>
								<Text
									style={{
										color: '#212121',
										fontSize: 14,
										fontWeight: mortgageData?.reportAppraisal === 'h1' ? 700 : 400
									}}>
									{t('appraisal.gibobs')}
								</Text>
							</Radio>
						)}
						{valueRadio === 'h1' && _.isNil(mortgageData?.appraiser) && (
							<div style={{ marginTop: 16 }}>
								<Text
									style={{
										fontSize: 12,
										fontWeight: 400,
										color: '#757575'
									}}>
									{t('appraisal.infoGibobs')}
								</Text>
							</div>
						)}
						{valueRadio === 'h1' && (
							<>
								<div style={{ marginTop: isClientPay ? -8 : 16 }}>
									<Text
										style={{
											fontSize: 12,
											fontWeight: 400,
											color: '#757575'
										}}>
										{!_.isNil(mortgageData?.appraiser) && isClientPay === false
											? t('appraisal.availableAppraisal')
											: isClientPay
											? existAppraisal
												? t('appraisal.reportAppraisalReady')
												: t('m_appraisal.paymentDone')
											: undefined}
									</Text>
								</div>
								<div style={{ marginTop: 16 }}>
									<div style={{ display: 'flex', alignItems: 'baseline' }}>
										<Text
											style={{
												color: '#212121',
												fontWeight: 400,
												fontSize: 14,
												marginRight: 5
											}}>
											{t('appraisal.appraiser')}
										</Text>
										<Text
											style={{
												color: '#006DFF',
												fontWeight: 700,
												fontSize: 14
											}}>
											{!_.isNil(mortgageData?.appraiser)
												? mortgageData?.appraiser
												: t('appraisal.confirm')}
										</Text>
									</div>
									<div style={{ display: 'flex', alignItems: 'baseline', marginBottom: 20 }}>
										<Text
											style={{
												color: '#212121',
												fontWeight: 400,
												fontSize: 14,
												marginRight: 5
											}}>
											{t('appraisal.price')}
										</Text>
										<Text
											style={{
												color: '#006DFF',
												fontWeight: 700,
												fontSize: 14
											}}>
											{!_.isNil(mortgageData?.appraisalAmount)
												? mortgageData?.appraisalAmount + ' €'
												: t('appraisal.confirm')}
										</Text>
									</div>
								</div>

								{valueRadio === 'h1' && !isClientPay && (
									<Button
										type="primary"
										onClick={() => payOk()}
										disabled={!_.isNil(dataMortgage.mortgage.appraisalAmount) ? false : true}
										style={{
											width: 120,
											borderRadius: '4px',
											textAlign: 'center',
											backgroundColor:
												dataMortgage.mortgage.appraiser !== undefined ? '#006DFF' : '#C0DAEE'
										}}>
										{t('appraisal.pay')}
									</Button>
								)}
							</>
						)}
					</Col>
				</Row>

				{valueRadio === 'h1' && !existAppraisal && isClientPay && (
					<div
						style={{
							padding: '8px 16px',
							border: '1px solid #006DFF',
							borderRadius: 4,
							display: 'inline-flex',
							alignItems: 'center',
							justifyContent: 'center',
							gap: 6
						}}>
						<ClockCircleOutlined style={{ color: '#006DFF', fontSize: 20 }} />
						<Text style={{ color: '#212121', fontSize: 14, fontWeight: 400 }}>
							{t('appraisal.infoAppraisal')}
						</Text>
					</div>
				)}
				{valueRadio === 'h1' &&
					existAppraisal &&
					isClientPay &&
					existAppraisal?.type === 'appraisal' && (
						<Button
							onClick={() => handleFileDownload(existAppraisal.id)}
							style={{
								padding: '8px 16px',
								border: '1px solid #239D45',
								borderRadius: 4,
								display: 'inline-flex',
								alignItems: 'center',
								justifyContent: 'center',
								gap: 6,
								marginBottom: 16,
								cursor: 'pointer'
							}}>
							<DownloadOutlined style={{ color: '#239D45', fontSize: 20 }} />
							<Text style={{ color: '#239D45', fontSize: 14, fontWeight: 400 }}>
								{t('appraisal.infoAppraisal')}
							</Text>
						</Button>
					)}
			</div>
		);
	};

	const payOk = () => {
		dispatch(showPay(true));
	};

	return (
		<>
			<div>
				{!showPayBoolean && (
					<div>
						<Text style={{ color: '#212121', fontSize: 16, fontWeight: 700 }}>
							{t('appraisal.infoAppraisal')}
						</Text>
						{renderSelect()}
						{!showPayBoolean && bankOffer && (
							<a
								href={`${env.api.url}/v1/banks/generate-pdf-bank/${bankOffer}?token=${userToken}`}
								target={'_blank'}>
								<div style={{ marginTop: 16, width: isMobileOnly ? '100%' : 250 }}>
									<Text style={{ fontSize: 12, fontWeight: 400, color: '#212121' }}>
										{t('offers.previousDocument')}
									</Text>
									<div
										style={{
											margin: '12px auto 0 auto',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											width: '95%',
											padding: 8,
											borderBottom: '1px solid #F1F7F8'
										}}>
										<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
											<FileOutlined style={{ color: '#006DFF', fontSize: 18 }} />
											<Text style={{ fontSize: 14, fontWeight: 400, color: '#212121' }}>
												{t('offers.selected')}
											</Text>
										</div>
										<DownloadOutlined style={{ color: '#212121', fontSize: 20 }} />
									</div>
								</div>
							</a>
						)}
					</div>
				)}
				{showPayBoolean && dataMortgage && (
					<div>
						<CheckOutComponent
							amount={dataMortgage?.mortgage?.appraisalAmount}
							showPayBoolean={showPayBoolean}
							mortgageId={operationId}
							clientSecretToken={dataClient?.paymentSeat?.session?.client_secret}
							dataClient={dataClient}
						/>
					</div>
				)}
			</div>
			<DeleteDocumentModal
				visible={deleteModal.show}
				onCreate={() => deleteDocument(deleteModal.documentId)}
				onCancel={() => setDeleteModal({ show: false, documentId: undefined })}
			/>
		</>
	);
};

export default Appraisal;
